export const cleanCompanyName = (subject: string): string => {
  if (!subject) return subject;
  return subject
    .replace("SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ", "sp. z o.o.")
    .trim();
};
